import React from 'react';
import { ModularButton } from '@components/ModularButton/ModularButton';
import { InternalLinkType } from '@appTypes/internalLinkType';
import { ExternalLinkType } from '@appTypes/externalLinkType';

interface ModularButtonSerializerProps {
  value: {
    primaryButton: {
      buttonText: string;
      variant?: string;
      internalLink?: InternalLinkType;
      externalLink?: ExternalLinkType;
    };
    secondaryButton?: {
      buttonText?: string;
      internalLink?: InternalLinkType;
      externalLink?: ExternalLinkType;
    };
  };
}

export const ModularButtonBlock = ({ value: { primaryButton, secondaryButton } }: ModularButtonSerializerProps) => (
  <ModularButton primaryButton={primaryButton} secondaryButton={secondaryButton} />
);
